import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Layout as AppLayout} from 'src/layouts/app';
import {paths} from "../paths";

const IndexPage = lazy(() => import('src/pages/call-center/index'));
const CreatePage = lazy(() => import('src/pages/call-center/create'));
const EditPage = lazy(() => import('src/pages/call-center/[caseID]/edit'));


export const CallCenterRoutes = [
    {
        path: 'call-center',
        element: (
            <AppLayout>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </AppLayout>
        ),
        children: [
            {
                index: true,
                element: <IndexPage/>
            },
            {
                path: paths.callCenter.create,
                element: <CreatePage/>
            },
            {
                path: paths.callCenter.edit,
                element: <EditPage/>
            },
        ]
    }
];
